import SubsectionTitle from './SubsectionTitle';

export default function DeliveryUI({ settings, cartAttributes }) {
	return (
		<div className="pickup-location-selector delivery-ui">
			<SubsectionTitle settings={settings} stepNumber={3} cartAttributes={cartAttributes} />
			<div className="delivery-ui__content">
				{settings.deliveryText && (
					<div className="delivery-ui__delivery-text">
						<p>{settings.deliveryText}</p>
					</div>
				)}

				{settings.deliveryImage && (
					<div className="delivery-ui__delivery-image">
						<div dangerouslySetInnerHTML={{ __html: settings.deliveryImage }} />
					</div>
				)}
			</div>
		</div>
	);
}
